import { useState, createContext } from 'react'
import { toast } from 'sonner'
import i18n from '../i18n'
import {
  createSimulation,
  listSimulations,
  updateSimulation,
  deleteSimulation
} from '../api/simulations';

const isPt = () => (i18n.language || 'pt').startsWith('pt');

export const SimulationContext = createContext({})

function SimulationProvider({ children }) {

    const [simulation, setSimularion] = useState([])

 async function saveSimulation(data) {
  try {
    const payload = {
      userId: data.userId,
      objetivo: data.objetivo,
      categoria: data.categoria,

      // ✅ objetivo simples
      metaDescricao: data.metaDescricao,
      metaValor: data.metaValor,

      // ✅ flags (tipo do objetivo)
      showAporteMensal: data.showAporteMensal,
      showCalculadora: data.showCalculadora,

      // valores (podem ser null se simples)
      valorinicial: data.valorinicial,
      aportemensal: data.aportemensal,
      tempoinvestido: data.tempoinvestido,
      rendimentomensal: data.rendimentomensal,

      // resultados (podem ser null se simples)
      saldofinal: data.saldofinal,
      retornomensal: data.retornomensal,
      retornoanual: data.retornoanual,
      totalmeses: data.totalmeses,
    };

    await createSimulation(payload);
    toast.success(isPt() ? 'Simulação cadastrada' : 'Goal saved');
    getSimulations(data.userId);
  } catch (err) {
    console.error('Erro ao criar simulação:', err);
    toast.error(isPt() ? 'Algo deu errado' : 'Something went wrong');
  }
}


async function getSimulations(userId) {
  try {
    const list = await listSimulations(userId);
    const mappedList = list.map(item => ({
      _id: item._id, 
      key: item._id,
      usuario: item.userId,
      objetivo: item.objetivo,

      // ✅ objetivo simples
      metaDescricao: item.metaDescricao,
      metaValor: item.metaValor,

      // ✅ flags
      showAporteMensal: item.showAporteMensal,
      showCalculadora: item.showCalculadora,

      valorinicial: item.valorinicial,
      aportemensal: item.aportemensal,
      tempoinvestido: item.tempoinvestido,
      rendimentomensal: item.rendimentomensal,
      saldofinal: item.saldofinal,
      retornomensal: item.retornomensal,
      retornoanual: item.retornoanual,
      totalmeses: item.totalmeses,
      totalAportado: item.totalAportado,
      percentualAtingido: item.percentualAtingido,
      faltaParaMeta: item.faltaParaMeta,
      categoria: item.categoria
    }));

    setSimularion(mappedList);
  } catch (error) {
    console.error('Erro ao buscar simulações:', error);
    setSimularion([]);
  }
}

            async function excluirSimulacao(idSimulacao, userId, mensagem = true) {
              try {
               await deleteSimulation(idSimulacao);

                if (mensagem) {
                  toast.success(isPt() ? 'Dados excluídos' : 'Deleted');
                }

                getSimulations(userId);
                } catch (err) {
                  console.error("Erro ao excluir simulação:", err?.response?.data || err?.message);
                  toast.error(isPt() ? 'Não foi possível excluir o registro, tente novamente mais tarde' : 'Could not delete. Try again later.');
                }
                }

 async function updateSimulacaoValues(data) {
  try {
    const payload = {
      userId: data.usuario,
      objetivo: data.objetivo,
      categoria: data.categoria,

      // ✅ objetivo simples
      metaDescricao: data.metaDescricao,
      metaValor: data.metaValor,

      // ✅ flags
      showAporteMensal: data.showAporteMensal,
      showCalculadora: data.showCalculadora,

      valorinicial: data.valorinicial,
      aportemensal: data.aportemensal,
      tempoinvestido: data.tempoinvestido,
      rendimentomensal: data.rendimentomensal,
      saldofinal: data.saldofinal,
      retornomensal: data.retornomensal,
      retornoanual: data.retornoanual,
      totalmeses: data.totalmeses,
    };

    await updateSimulation(data.key, payload);
    toast.success(isPt() ? 'Alterado com sucesso' : 'Updated');
    getSimulations(data.usuario);
  } catch (err) {
    console.error('Erro ao atualizar simulação:', err);
    toast.error(isPt() ? 'Erro' : 'Error');
  }
}

    return (
        <SimulationContext.Provider value={{
            saveSimulation,
            getSimulations,
            simulation,
            setSimularion,
            updateSimulacaoValues,
            excluirSimulacao
        }}>
            {children}
        </SimulationContext.Provider>
    )
}

export default SimulationProvider;
